import * as React from "react";
import { useEffect } from "react";
import throttle from "lodash.throttle";

import { toNumber } from "../helpers";

const EVENTS = [
  "mousemove",
  "keydown",
  "wheel",
  "DOMMouseScroll",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "MSPointerDown",
  "MSPointerMove",
];

const updateTimer = () => {
  const idleTimer = toNumber(localStorage.getItem("lastInteractionTime") ?? "0");
  const now = Date.now();
  if ((idleTimer ?? 0) < now) {
    localStorage.setItem("lastInteractionTime", now.toString());
  }
};

const isTimeOut = (timeout: number) => {
  const idleTimer = toNumber(localStorage.getItem("lastInteractionTime") ?? "0");
  const now = Date.now();
  return idleTimer !== 0 && now - (idleTimer ?? now) > timeout;
};

const onAction = throttle(() => {
  updateTimer();
}, 1000);

export const IdleHandler: React.FC<{ timeout: number; interval?: number; onIdle: () => void }> = ({
  timeout,
  interval = 10000,
  onIdle,
}) => {
  useEffect(() => {
    updateTimer();

    EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onAction);
    });

    return () => {
      EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onAction);
      });
    };
  }, []);

  useEffect(() => {
    const checkTimeoutInterval = setInterval(() => {
      if (isTimeOut(timeout)) {
        clearInterval(checkTimeoutInterval);
        onIdle();
      }
    }, interval);

    return () => {
      clearInterval(checkTimeoutInterval);
    };
  }, [interval, onIdle, timeout]);
  return <></>;
};
